export type JoinSubscriptionConfirmPaymentButtonNewProps = {
  subscriptionPlanId: string;
};
export type JoinSubscriptionConfirmPaymentButtonProps = {
  userPaymentMethodId: string;
  onCompleted: () => void;
} & JoinSubscriptionConfirmPaymentButtonNewProps;

export type PayBy = {
  userPaymentMethodId?: string;
  type: PaymentMethodTypeEnum;
};

export enum PaymentMethodTypeEnum {
  CreditCard = "creditCard",
  Offline = "offline",
}
